import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEditProfileImage = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: .700195,
			y: .699951,
			width: 23.4,
			height: 23.4,
			rx: 11.7,
			stroke: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.4002 1.19995C6.22433 1.19995 1.2002 6.22408 1.2002 12.4C1.2002 18.5758 6.22433 23.5999 12.4002 23.5999C18.5761 23.5999 23.6002 18.5758 23.6002 12.4C23.6002 6.22408 18.5761 1.19995 12.4002 1.19995Z",
			fill: "#2C70EC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.94 9.33966L14.3808 7.8999L16.9004 10.42L15.4601 11.8597M12.94 9.33966L8.04956 14.2307C7.95408 14.3261 7.90042 14.4556 7.90039 14.5906V16.8999H10.2097C10.3447 16.8999 10.4742 16.8462 10.5696 16.7507L15.4601 11.8597M12.94 9.33966L15.4601 11.8597",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgEditProfileImage;
